import { get } from "lodash";
import { Auth } from "types/Auth";
import BaseService from "../Base";
import apiUrls from "../ApiUrl";

class AgencyService extends BaseService {
  constructor() {
    super(process.env.REACT_APP_API_BASE_URL);
  }

  
  async list(data = {}): Promise<any> {
    try {
      const response = await this.post(`${apiUrls.agency}/list`, data);
      return get(response, "data", {});
    } catch (e: any) {
      throw e?.response?.data;
    }
  }
  
  async listAll(data = {}): Promise<any> {
    try {
      const response = await this.post(`${apiUrls.agency}/list-all-users`, data);
      return get(response, "data", {});
    } catch (e: any) {
      throw e?.response?.data;
    }
  }

  async listUsersWithPressReleaseDetail(data = {}): Promise<any> {
    try {
      const response = await this.post(`${apiUrls.agency}/list-user-with-pressRelease`, data);
      return get(response, "data", {});
    } catch (e: any) {
      throw e?.response?.data;
    }
  }
  async dashboard(data = {}): Promise<any> {
    try {
      const response = await this.post(`${apiUrls.agency}/dashboard`, data);
      return get(response, "data", {});
    } catch (e: any) {
      throw e?.response?.data;
    }
  }

}

export default AgencyService;
